module.exports = "<div class=\"col-12\">\r\n    <div class=\"row marg task status-{{taskstatus}}\">\r\n        <div class=\"col-8\">{{name}}</div>\r\n        <div class=\"col-3 dutedate\">Due: {{duedate}}</div>\r\n        <div class=\"col-1 status\">\r\n            <a class=\"btn btn-circle big-shadow\" (click)=\"onButtonClicked($event);\" href=\"javascript: void(0)\">\r\n                <span class=\"btn-content\">Next</span>\r\n            </a>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/stage/components/task/task.component.html
// module id = ./src/app/stage/components/task/task.component.html
// module chunks = main